import React, { useState } from 'react'
import styles from './customPopup.module.css'

export default function CustomPopup({
    isShow,
    handelClosePopup,
    popupTitle,
    popupMessage,
    onConfirm,       // when provided, shows a "Continue" action button
    confirmLabel,    // button label, defaults to "Continue"
}) {
    return (
        <>
            {isShow && (
                <div className={styles.overlay}>
                    <div className={styles.popup}>
                        <h3>{popupTitle}</h3>
                        <p style={{ whiteSpace: 'pre-line', textAlign: 'left', margin: '12px 0' }}>
                            {popupMessage}
                        </p>
                        {onConfirm ? (
                            <button
                                onClick={onConfirm}
                                style={{
                                    marginTop: 8,
                                    padding: '8px 24px',
                                    background: '#4CAF50',
                                    color: '#fff',
                                    border: 'none',
                                    borderRadius: 4,
                                    cursor: 'pointer',
                                    fontSize: 14,
                                    fontWeight: 600,
                                }}
                            >
                                {confirmLabel || 'Continue'}
                            </button>
                        ) : (
                            <button
                                onClick={handelClosePopup}
                                style={{
                                    marginTop: 8,
                                    padding: '8px 24px',
                                    background: '#2196F3',
                                    color: '#fff',
                                    border: 'none',
                                    borderRadius: 4,
                                    cursor: 'pointer',
                                    fontSize: 14,
                                    fontWeight: 600,
                                }}
                            >
                                OK
                            </button>
                        )}
                    </div>
                </div>
            )}
        </>
    )
}
